module.exports = __webpack_public_path__ + "img/178.79fb3f38.jpg";